module.exports = __webpack_public_path__ + "static/media/Battery.9d20b233.svg";